import React, { useState } from 'react';
import LoadingSpinner from './LoadingSpinner';

const LazyImage = ({ 
  src, 
  alt, 
  className, 
  width, 
  height, 
  aspectRatio = 'aspect-[4/3]', 
  loading = 'lazy',
  fetchPriority = 'auto',
  onLoad, 
  onError, 
  ...props 
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
    if (onLoad) onLoad();
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
    if (onError) onError();
  };

  if (hasError) {
    return (
      <div className={`${className} ${aspectRatio || ''} bg-gray-100 flex items-center justify-center`}>
        <div className="text-center p-4">
          <div className="text-gray-400 mb-2">❌</div>
          <p className="text-gray-500 text-sm">שגיאה בטעינת התמונה</p>
        </div>
      </div>
    );
  }

  // If no aspectRatio specified, render image directly without container
  if (!aspectRatio) {
    return (
      <>
        {isLoading && (
          <div className={`${className} bg-gray-100 flex items-center justify-center absolute inset-0 z-10`}>
            <LoadingSpinner size="small" message="" />
          </div>
        )}
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
          onLoad={handleLoad}
          onError={handleError}
          loading={loading}
          fetchPriority={fetchPriority}
          decoding="async"
          {...props}
        />
      </>
    );
  }

  return (
    <div className={`relative ${aspectRatio}`}>
      {isLoading && (
        <div className={`${className} bg-gray-100 flex items-center justify-center absolute inset-0 z-10`}>
          <LoadingSpinner size="small" message="" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
        onLoad={handleLoad}
        onError={handleError}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        {...props}
      />
    </div>
  );
};

export default LazyImage;